import React from 'react';
import { motion } from 'framer-motion';
import SectionLabel from '../ui/SectionLabel';
import RollingCounter from '../ui/RollingCounter';

const stats = [
  { value: 150, suffix: '+', label: 'Projects Delivered' },
  { value: 6, suffix: '+', label: 'Years Experience' },
  { value: 50, suffix: '+', label: 'Happy Clients' },
  { value: 15, suffix: '+', label: 'Countries Served' },
];

export default function StatsSection() {
  return (
    <section id="about" className="relative py-24 md:py-32" style={{ background: 'rgba(5,5,16,0.45)', backdropFilter: 'blur(4px)' }}>
      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <SectionLabel className="justify-center">Why Choose Us</SectionLabel>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="text-[clamp(2rem,4vw,3.5rem)] font-bold font-space text-[#F0F0F5] tracking-[-0.02em] mb-6"
          >
            We turn bold ideas into powerful digital realities.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-[#8A8AA3] text-lg leading-relaxed"
          >
            With deep expertise across AI, blockchain, and full-stack development, we partner with
            ambitious teams to build products that scale and endure.
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
              className="text-center p-6 md:p-8 rounded-2xl bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)] hover:border-[rgba(0,212,255,0.15)] transition-all duration-300"
            >
              <div className="text-4xl md:text-5xl font-bold font-space text-[#00D4FF] mb-2">
                <RollingCounter end={s.value} suffix={s.suffix} />
              </div>
              <p className="text-[#8A8AA3] text-sm">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
